import { render, staticRenderFns } from "./OffersHeader.vue?vue&type=template&id=49c06b44&scoped=true"
import script from "./OffersHeader.vue?vue&type=script&lang=js"
export * from "./OffersHeader.vue?vue&type=script&lang=js"
import style0 from "./OffersHeader.vue?vue&type=style&index=0&id=49c06b44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c06b44",
  null
  
)

export default component.exports